import tw from "twin.macro";

import Text from "app/styles/Text";
import { useAppState } from "app/providers/AppStateProvider";

import { formatMoney } from "app/lib/money";
import { useNavigate } from "react-router-dom";
import BackButton from "app/components/BackButton";

export default function PageHeader({ hasBackButton = false }: { hasBackButton?: boolean }) {
  const { merchant } = useAppState();
  const navigate = useNavigate();

  return (
    <div tw="w-full">
      {hasBackButton && (
        <BackButton onClick={() => navigate(-1)} />
      )}

      <div tw="flex flex-col gap-[4px]">
        <h4 css={tw`headline-medium`}>
          Pay
          {formatMoney(
            Number(
              merchant.quote_amount
            ),
            undefined,
            ""
          )}{" "}
          {merchant.quote_currency}
        </h4>

        <Text medium mediumBold>To {merchant.business_name}</Text>
      </div>
    </div>
  );
}
